module.exports = __webpack_public_path__ + "img/duanxin.2f4d9bfa.png";